import { Injectable } from '@angular/core';
import { ApiHttpService } from './api_http.service';
import { Observable, of, throwError } from 'rxjs';
import { PLATFORM_TYPES } from './constants/platform_types';
import { DEFAULT_INTENT } from '../../signup/platform/state/product_intent';
import { PlatformAnalyticsDataService } from '@yotpo-ui/platform-core';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class AccountService {
  constructor(private apiHttp: ApiHttpService,
              private platformAnalyticsDataService: PlatformAnalyticsDataService,
              private authenticationService: AuthService) {
  }

  getAccountMapStyle(): Observable<any> {
    return this.apiHttp.get('apps/:app_key/map_style');
  }

  getAppData(): Observable<any> {
    return this.apiHttp.get('apps/:app_key');
  }

  getPlatformAdminLinks(): Observable<any> {
    return this.apiHttp.get('apps/:app_key/account_platform/admin_links');
  }

  enable_product(params) {
    return this.apiHttp.post('account_system/enable_product_for_account', params);
  }

  updateAppData(options) {
    if (options == null) {
      return throwError('empty argument');
    }
    let params = {account: options};
    return this.apiHttp.put('apps/:app_key', params);
  }

  notifyPlatformWithPastOrders() {
    return this.apiHttp.post('account_platform/notify_platform_with_past_orders');
  }

  completeRegistration(monthlyOrders?: string, phone?: string): Observable<any> {
    if (!monthlyOrders && !phone) {
      return of({});
    }

    let params = {};
    if (monthlyOrders) {
      params['signup_monthly_order_volume'] = monthlyOrders;
    }
    if (phone) {
      params['signup_phone'] = phone;
    }

    this.platformAnalyticsDataService.clearCache();
    return this.apiHttp.post('v1/apps/:app_key/complete_registration', params);
  }

  buildEnableProductParams(platform, shop_domain, category, phone = null, maxMonthlyOrders = null) {
    let params = {
      store_info: {
        app_key: this.authenticationService.getCredentials().appKey,
        domain: shop_domain,
        name: shop_domain
      },
      platform_info: {
        name: this.getPlatformByKey('name', platform.toLowerCase()) ||
          this.getPlatformByKey('id', platform)
      },
      category: category || DEFAULT_INTENT,
      action_params: { context: 'signup' }
    };

    if (phone) {
      params['admin_info'] = { phone: phone };
    }

    if (maxMonthlyOrders) {
      params.action_params['account_stats'] = { signup_monthly_order_volume: maxMonthlyOrders };
    }

    return params;
  }

  private getPlatformByKey(key, lookupValue) {
    let platform = PLATFORM_TYPES.find(pt => pt[key].toLowerCase() === lookupValue);
    return platform ? platform.name : undefined;
  }
}
